import type { PlanStockInput, StockHeaderItemInput } from "@/lib/gql/__generated__/graphql";

import type { PlanStockDiffStore } from "../../../../usecase/use-create-form-model/plan-stock-diff-store";
import type { ServerModel } from "../../../../usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	planStockDiffStore: PlanStockDiffStore;
};

export const convertToViewModelToInput = ({ serverModel, planStockDiffStore }: Props) => {
	const input = {
		hotelID: serverModel.planStock.hotelID,
		headers: serverModel.planStock.headers.map(
			(header) =>
				({
					date: header.date,
				}) satisfies StockHeaderItemInput,
		),
		items: planStockDiffStore.getDiffItems(),
	} satisfies PlanStockInput;

	return input;
};
